import React from 'react';
import { Card } from './ui/card';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
import { clinicInfo } from '../mock';

const ContactSection = () => {
  return (
    <section id="contact" className="py-20 bg-gradient-to-b from-white via-teal-50/30 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="section-title mb-4 bg-gradient-to-r from-teal-600 to-cyan-600 bg-clip-text text-transparent">Visit Us</h2>
          <p className="section-description">
            We're here to help you on your wellness journey
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          {/* Contact Information Cards */}
          <div className="space-y-6">
            <Card className="p-6 hover:shadow-xl transition-shadow border-2 border-cyan-200">
              <div className="flex items-start">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-cyan-400 to-teal-500 flex items-center justify-center mr-4 flex-shrink-0">
                  <MapPin className="h-6 w-6 text-white" />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Location</h3>
                  <p className="text-gray-600">
                    {clinicInfo.address.street}<br />
                    {clinicInfo.address.city}, {clinicInfo.address.province}<br />
                    {clinicInfo.address.postalCode}
                  </p>
                </div>
              </div>
            </Card>

            <Card className="p-6 hover:shadow-xl transition-shadow border-2 border-cyan-200">
              <div className="flex items-start">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-cyan-400 to-teal-500 flex items-center justify-center mr-4 flex-shrink-0">
                  <Phone className="h-6 w-6 text-white" />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Phone</h3>
                  <a
                    href={`tel:${clinicInfo.phone.replace(/-/g, '')}`}
                    className="text-lg text-cyan-600 hover:text-cyan-700 font-medium"
                  >
                    {clinicInfo.phone}
                  </a>
                  <p className="text-gray-600 text-sm mt-1">Call us for appointments</p>
                </div>
              </div>
            </Card>

            <Card className="p-6 hover:shadow-xl transition-shadow border-2 border-cyan-200">
              <div className="flex items-start">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-cyan-400 to-teal-500 flex items-center justify-center mr-4 flex-shrink-0">
                  <Mail className="h-6 w-6 text-white" />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Email</h3>
                  <a
                    href={`mailto:${clinicInfo.email}`}
                    className="text-lg text-cyan-600 hover:text-cyan-700 font-medium break-all"
                  >
                    {clinicInfo.email}
                  </a>
                  <p className="text-gray-600 text-sm mt-1">Send us your inquiries</p>
                </div>
              </div>
            </Card>

            <Card className="p-6 hover:shadow-xl transition-shadow border-2 border-cyan-200">
              <div className="flex items-start">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-cyan-400 to-teal-500 flex items-center justify-center mr-4 flex-shrink-0">
                  <Clock className="h-6 w-6 text-white" />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">Hours</h3>
                  <div className="space-y-2 text-gray-600">
                    <div className="flex justify-between">
                      <span className="font-medium">Mon - Sun:</span>
                      <span>10:00 AM - 7:00 PM</span>
                    </div>
                  </div>
                </div>
              </div>
            </Card>
          </div>

          {/* Map */}
          <div className="lg:sticky lg:top-24">
            <Card className="overflow-hidden border-2 border-cyan-200">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2896.4824687157756!2d-80.45363908450897!3d43.42089197913051!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882bf4db9b1b7b6f%3A0x1234567890abcdef!2s3160%20King%20St%20E%2C%20Kitchener%2C%20ON%20N2A%201B3!5e0!3m2!1sen!2sca!4v1620000000000!5m2!1sen!2sca"
                width="100%"
                height="500"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Shubh Wellness Clinic Location"
                className="w-full"
              ></iframe>
            </Card>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
